export default "/_next/static/images/img2-2feb132592967eb4ad8368556aab326a.png";